import API from '../../services/API'
import EuropeanCountryTrigrams from '../../datasets/european-countries-trigrams'

export async function getCountryList(ctx: any, { lang }: any = {}) {
    try {
        const countryListObject = await API.getApplyAvailableCountries(lang)
        const countryList = {
            preferred: Object.keys(countryListObject[0]).map(key => ({
                label: countryListObject[0][key],
                value: key,
                isEu: EuropeanCountryTrigrams.includes(key),
            })),
            all: Object.keys(countryListObject[1]).map(key => ({
                label: countryListObject[1][key],
                value: key,
                isEu: EuropeanCountryTrigrams.includes(key),
            })),
        }
        ctx.commit('SET_COUNTRY_LIST', { countryList })
    } catch (e) {
        console.warn(e)
    }
}
